/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Processing view for the impact evaluation

Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from "react";
import { Container, Row , Alert} from "reactstrap";
import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router-dom";
import { getPetition } from "../../api/api";
import Spinner from 'react-bootstrap/Spinner';
import classNames from 'classnames';


export default function Processing() {
    const navigate = useNavigate()
    const { missionId, taskId } = useParams()
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState('')

    useEffect(() => {
        const checkTaskStatus = async () => {

            if(window.location.pathname.includes('loading')){
            const response = await getPetition(`/api/processing/result?task_id=${taskId}`);
            if (response && response.status === 'PENDING') {
                setTimeout(checkTaskStatus, 30000);
            } else if (response && response.status === 'SUCCESS') {
                navigate(`/impact-evaluation/output/${missionId}`)
            }
            else if (response && response.status === 'FAILURE') {
                setErrorText(response.result)
                setError(true)
            }
        }
        };

        checkTaskStatus();

        return () => {
            setError(false)
            setErrorText('')
        }

    }, [missionId, taskId, navigate]);

    if (error) {
        return (
            <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
                <Container className="align-center ">
                    <Row className="justify-content-center mb-4">
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                            <span style={{ borderRadius: 20, width: 50 }} className="avatar-title bg-success-lighten text-success">
                                <i className={classNames('uil uil-check', 'font-24')}></i>
                            </span>

                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                                <h5 style={{ color: '#003247' }} className="header-title">Create Mission</h5>
                            </div>
                        </div>

                    </Row>
                    <Row className="justify-content-center">

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                            <span style={{ borderRadius: 20, width: 50 }} className="avatar-title bg-danger-lighten text-danger">
                                <i className={classNames(' dripicons-cross', 'font-22')}></i>
                            </span>

                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                                <h5 style={{ color: '#003247' }} className="header-title">Calculting Mission</h5>
                            </div>
                        </div>

                    </Row>
                    <Row className="justify-content-center mt-4">
                        <Alert color="danger">
                          
                            <p>
                                {errorText}
                            </p>
                        </Alert>
                    </Row>

                </Container>
            </div>
        )
    }

    return (

        <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
            <Container className="align-center ">
                <Row className="justify-content-center mb-4">
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                        <span style={{ borderRadius: 20, width: 50 }} className="avatar-title bg-success-lighten text-success">
                            <i className={classNames('uil uil-check', 'font-24')}></i>
                        </span>

                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                            <h5 style={{ color: '#003247' }} className="header-title">Create Mission</h5>
                        </div>
                    </div>

                </Row>
                <Row className="justify-content-center">

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                        <span style={{ borderRadius: 20, width: 50 }} className="avatar-title">
                            <Spinner />
                        </span>

                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                            <h5 style={{ color: '#003247' }} className="header-title">Evaluating environmental impact</h5>
                        </div>
                    </div>

                </Row>
                <Row className="justify-content-center">

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop:20 }}>
                       
                        <div style={{ width: '100%', display: 'flex', 
                        justifyContent: 'center', 
                        alignContent: 'center', 
                         alignItems: 'center',
                         gap: 10
                        }}>
                            <h5 style={{ color: '#003247' }} className="header-title">Results will be ready in the following URL: </h5>
                            <a href={`/impact-evaluation/output/${missionId}`}>  /impact-evaluation/output/{missionId}</a>
                        </div>
                    </div>

                </Row>
            </Container>
        </div>
    );
}
